import React from "react";
import { createRoot } from "react-dom/client";
import GlobalStyle from "./styles/global";
import Routes from "./routes";
import { AuthProvider } from "./contexts/AuthContext";
import * as serviceWorker from "./serviceWorker";

const root = createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <AuthProvider>
      <Routes />
    </AuthProvider>
    <GlobalStyle />
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
